import { ConnectionTypesState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectConnectionTypesReducer = (state: RootState): ConnectionTypesState => state.connectionTypes;

export const selectConnectionTypesIsEmpty = createSelector(
  [selectConnectionTypesReducer],
  (connectionTypes) => connectionTypes.connectionTypesIsEmpty
);

export const selectConnectionTypesLoading = createSelector(
  [selectConnectionTypesReducer],
  (connectionTypes) => connectionTypes.connectionTypesLoading
);

export const selectConnectionTypes = createSelector(
  [selectConnectionTypesReducer],
  (connectionTypes) => connectionTypes.connectionTypes
);
